import { Injectable, Injector } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs/operators';
import { SharedAnalyticsService } from '../../analytics/shared-analytics/shared-analytics.service';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private previousUrl: string | null = null;
  private currentUrl: string | null = null;

  /**
   * Creates an instance of NavigationService.
   * Initializes URL tracking by setting the current URL and subscribing to router navigation events.
   * When navigation completes, updates the current and previous URL properties to maintain navigation history.
   * 
   * @param router - Angular Router instance used to track navigation events and retrieve URLs
   */
  constructor(
    private router: Router,
    private injector: Injector
  ) {
    this.currentUrl = this.router.url;
    router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        debounceTime(300),
        distinctUntilChanged((prev, curr) => prev.url === curr.url)
      )
      .subscribe(async (event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.url;

        try {
          // Lógica nueva: trackPageView con SharedAnalyticsService
          const sharedAnalyticsS = this.injector.get(SharedAnalyticsService);
          const pageViewConfig = sharedAnalyticsS.getPageViewConfig(event.urlAfterRedirects);
          if (pageViewConfig) {
            sharedAnalyticsS.trackPageView(pageViewConfig, pageViewConfig.section);
          }
        } catch (error) {
          // Evitar fallas si el inyector o servicio no están disponibles
        }
      });
  }


  /**
   * Gets the current navigation URL.
   * 
   * @returns The current URL as a string, or null if no URL is set
   */
  public getCurrentUrl(): string | null {
    return this.currentUrl;
  }

  /**
   * Retrieves the URL of the previously visited page.
   * 
   * @returns The previous URL as a string, or null if no previous URL is available
   */
  public getPreviousUrl(): string | null {
    return this.previousUrl;
  }
}
